import { Navigate } from '@sorare/routing';
import { ANY_SPORT_ONBOARDING_PRO_DISCOVER } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const OnboardingProPage = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_ONBOARDING_PRO_DISCOVER)}
      replace
    />
  );
};

export default OnboardingProPage;
